import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';

const SelectedChoices = (_param)=>{
    var { className , choices  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "choices"
    ]);
    return Object.keys(choices).length > 0 ? /*#__PURE__*/ React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('selected-choices', className)
    }), Object.entries(choices).map(([choice, { name , action , onClick  }], index)=>/*#__PURE__*/ React.createElement("li", {
            key: `${choice}-${name}`,
            className: classnames('selected-choices__list-item', {
                'selected-choices__list-item--grouped': Object.entries(choices).length > 1
            })
        }, /*#__PURE__*/ React.createElement("button", {
            className: "selected-choices__button",
            onClick: onClick,
            type: "button"
        }, /*#__PURE__*/ React.createElement(Text, {
            className: "selected-choices__name",
            variant: "caption"
        }, name), /*#__PURE__*/ React.createElement(Text, {
            variant: "caption",
            "data-t": `changeSelectedChoice${index + 1}`,
            color: "primary"
        }, action)))
    )) : null;
};

export { SelectedChoices as default };
//# sourceMappingURL=SelectedChoices.js.map
